import { Injectable } from '@angular/core';
// interfaces
import { Application, Role as RoleDto } from './../../cemexcomponents/types/v2/';
import { StorageManagerService } from '@app/core/services/storage-manager.service';

// tslint:disable:no-unused-expression
@Injectable()
export class RolesService {
  public get applications(): Application[] {
    return this.getUserApplications();
  }

  public get roles(): RoleDto[] {
    return this.getUserRoles();
  }

  private applicationCode = 'INVOICE_PAYMENTS';
  private ordersProductsApplicationCode = 'OrderProductCat_App';
  private construagilApplicationCode = 'Construagil_App';

  constructor(private storageManagerService: StorageManagerService,
  ) { }

  public isInCurrentApplication() {
    for (const app of this.applications) {
      if (app.applicationCode === this.applicationCode) {
        return true;
      }
    }
    return false;
  }

  public isInOrdersProductsApplication() {
    for (const app of this.applications) {
      if (app.applicationCode === this.ordersProductsApplicationCode) {
        return true;
      }
    }

    return false;
  }

  public isInConstruagilApplication() {
    for (const app of this.applications) {
      if (app.applicationCode === this.construagilApplicationCode) {
        return true;
      }
    }
    return false;
  }

  public getUserApplications(): Application[] {
    if (this.storageManagerService.user_applications !== undefined &&
      this.storageManagerService.user_applications !== null) {
      return this.storageManagerService.user_applications;
    }
    return [];
  }

  /**
   * @description Get the user roles in the current application
   */
  public getUserRoles(): RoleDto[] {
    let roles = [];
    this.applications && this.applications.forEach(($app) => {
      if ($app.applicationCode === this.applicationCode) {
        roles = roles.concat($app.roles);
      }

      if ($app.applicationCode === this.construagilApplicationCode) {
        roles = roles.concat($app.roles);
      }
    });
    return roles;
  }

  /**
   * @description Get the user roles of every application it has access to
   */
  public getAllUserRoles(): RoleDto[] {
    let roles = [];
    this.applications && this.applications.forEach(($app) => {
      roles = roles.concat($app.roles);
    });

    return roles;
  }

  // =============================================================================================

  public isDisputeManager(): boolean {
    return this.hasRole('ARMSTAFFDM');
  }

  public isAccountsPayableClerk(): boolean {
    return this.hasRole('ARMORGAPC') || this.hasRole('CAORGAPC') || this.hasRole('ARMSTAFFAPC');
  }

  public isAccountsPayableClerkAp(): boolean {
    return this.hasRole('ARMORGARCADV') || this.hasRole('CAORGARCADV') || this.hasRole('ARMSTAFFAPC');
  }

  public isAccountsPayableSupervisor(): boolean {
    return this.hasRole('ARMORGAPS');
  }

  public isAccountsReceivableUser(): boolean {
    return this.hasRole('ARMORGARU');
  }

  public isAccountsReceivableClerk(): boolean {
    return this.hasRole('ARMSTAFFARC');
  }

  public isSalesRepresentative(): boolean {
    return this.hasRole('ARMSTAFFSR');
  }

  public isSalesRepresentativeCement(): boolean {
    return this.hasRole('ARMSTAFFSRCEMENT');
  }

  public isSalesRepresentativeCementM(): boolean {
    return this.hasRole('ARMSTAFFSRMCEMENT');
  }

  public isSalesRepresentativeManager(): boolean {
    return this.hasRole('ARMSTAFFSRM');
  }

  public isUserReconcile(): boolean {
    return this.hasRole('ARMORGRECONCILE') || this.hasRole('ARMSTAFFRECONCILE');
  }

  public isUserCash(): boolean {
    return this.hasRole('ARMORGCASH');
  }

  public isUserLien(): boolean {
    return this.hasRole('ARMORGLIEN');
  }

  public isConfigurationManagement(): boolean {
    return this.hasRole('ARMSTAFFSCONF');
  }

  public isCreditRequestManagement(): boolean {
    return this.hasRole('ARMSTAFFREQUESTCREDIT');
  }

  public isUserGoodReceipt(): boolean {
    return this.hasRole('ARMORGGOODRECEIPT') || this.hasRole('ARMSTAFFGOODRECEIPT');
  }

  public isConstruagilUser(): boolean {
    return this.applications
      .some(x => x.applicationCode.toUpperCase() === 'CONSTRUAGIL_APP') && (this.hasRole('CAORGARCADV') || this.hasRole('CAORGAPC'));
  }

  public isRoleInApplication(applicationCode: string, roleCode: string) {
    const application = this.applications.find(x => x.applicationCode.toUpperCase() === applicationCode.toUpperCase());
    let hasAccess: boolean = false;

    if (application === undefined) return false;

    hasAccess = application.roles.some(x => x.roleCode.toUpperCase() === roleCode.toUpperCase());

    return hasAccess;
  }

  public isAccountsPayableClerkApInApplication(applicationCode: string): boolean {
    if (applicationCode === undefined) return false;
    const application = this.applications.find(x => x.applicationCode.toUpperCase() === applicationCode.toUpperCase());
    let hasAccess: boolean = false;

    if (application === undefined) return false;
    if (application.roles === undefined) return false;

    hasAccess = application.roles.some(x => this.hasRole(x.roleCode.toUpperCase()));

    return hasAccess;
  }

  public isUserCashSales(): boolean {
    let rolesCS = [];
    if (this.applications) {
      if (this.applications.length > 0) {
        this.applications.forEach(($app) => {
          if ($app.applicationCode === 'OrderProductCat_App') {
            rolesCS = $app.roles;
          }
        });
        return rolesCS.find(($role) => $role.roleCode.toUpperCase() === 'OPC_FORMAN' ||
          $role.roleCode.toUpperCase() === 'OPC_PO_MGR' ||
          $role.roleCode.toUpperCase() === 'OPC_CUST_OWNER') !== undefined;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  private hasRole(roleCode: string): boolean {
    return this.roles.find(($role) => $role.roleCode.toUpperCase() === roleCode) !== undefined;
  }

  public haveAccess(): boolean {
    const haveAccess = this.getUserApplications();
    return haveAccess.find(($app) => $app.applicationCode.toUpperCase() === this.applicationCode.toUpperCase()) !== undefined;
  }

}

export enum Roles {
  ARMORGAPC,
  ARMORGARCAdv,
  ARMORGreconcile,
  ARMSTAFFReconcile,
  ARMORGLIEN,
  ARMORGAPS,
  ARMORGARU,
  ARMORGCash,
  ARMSTAFFARC,
  ARMSTAFFDM,
  ARMSTAFFSR,
  ARMSTAFFSRCEMENT,
  ARMSTAFFSRM,
  ARMSTAFFSRMCEMENT,
  ARMSTAFFSCONF,
  Application,
  OrdersProductsApplication,
  OPC_FORMAN,
  OPC_PO_MGR,
  OPC_CUST_OWNER,
  ARMORGGOODRECEIPT,
  ARMSTAFFGOODRECEIPT,
  SECMORGROOT,
  ARMSTAFFREQUESTCREDIT,
  ARMORGREQUESTCREDIT,
  CAORGAPC,
  CAORGARCADV,
  ConstruagilApplication,
  ARMSTAFFAPC
}

export type Role =
  'ARMORGAPC'
  | 'ARMORGARCAdv'
  | 'ARMORGreconcile'
  | 'ARMSTAFFReconcile'
  | 'ARMORGLIEN'
  | 'ARMORGAPS'
  | 'ARMORGARU'
  | 'ARMORGCash'
  | 'ARMSTAFFARC'
  | 'ARMSTAFFDM'
  | 'ARMSTAFFSR'
  | 'ARMSTAFFSRCEMENT'
  | 'ARMSTAFFSRM'
  | 'ARMSTAFFSRMCEMENT'
  | 'ARMSTAFFSCONF'
  | 'OrdersProductsApplication'
  | 'OPC_FORMAN'
  | 'OPC_PO_MGR'
  | 'OPC_CUST_OWNER'
  | 'ARMORGGOODRECEIPT'
  | 'ARMSTAFFGOODRECEIPT'
  | 'SECMORGROOT'
  | 'ARMSTAFFREQUESTCREDIT'
  | 'ARMORGREQUESTCREDIT'
  | 'CAORGAPC'
  | 'CAORGARCADV'
  | 'ARMSTAFFAPC'
